import React from 'react';
import { Modal } from 'client/components/common/Modal';

type Props = {
  workingHourOptionList: JSX.Element;
  handlers: {
    handleClickClose: () => void;
    handleClickClear: () => void;
  };
};

export const WorkingHourOptionModal = ({
  workingHourOptionList,
  handlers: { handleClickClear, handleClickClose },
}: Props) => {
  return (
    <>
      <Modal title="時間帯" onClose={handleClickClose} onClear={handleClickClear}>
        <div>
          <div className="my-4 mx-5 font-bold">{workingHourOptionList}</div>
        </div>
      </Modal>
      );
    </>
  );
};
